import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let patientName = class patientName extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], patientName.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], patientName.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], patientName.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], patientName.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], patientName.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})
// eslint-disable-next-line
// watchIndex() {}
, Prop({
  type: Object,
  default: {}
})], patientName.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], patientName.prototype, "dataChage", null);
patientName = __decorate([Component({
  name: "patientName"
})], patientName);
export default patientName;